module.exports = __webpack_public_path__ + "/a680411eac077ab4bb2ed08687762d8b.woff";